/** @format */

import {Modal, ModalHeader, ModalFooter} from '@sttark/design-system';
import {usePaymentsContext} from '../payments_context_provider';
import {IfElse, If} from 'frontier-utilities';
import SuperAgent from 'superagent';
import React from 'react';

export const ActionColumn = props => {
    const {paymentProfile, onSuccessfulRemove} = props;

    const {removeProfileById} = usePaymentsContext();

    const [isEditingPaymentMethod, setIsEditingPaymentMethod] = React.useState({});
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [isDeleting, setIsDeleting] = React.useState(false);

    const handleRemove = () => {
        setIsDeleting(true);
        SuperAgent.delete('/account/users/disable-payment-profile/' + paymentProfile.id)
            .set('Accept', 'application/json')
            .end(() => {
                removeProfileById(paymentProfile.id);
                onSuccessfulRemove();
                setIsModalOpen(false);
                setIsDeleting(false);
            });
    };

    return (
        <div className="payment-form-93ht-table__action">
            <If condition={!!isEditingPaymentMethod.id}>
                <></>
            </If>
            <Modal isOpen={isModalOpen} bodyHeightAuto onClose={() => setIsModalOpen(false)}>
                <ModalHeader onClose={() => setIsModalOpen(false)}>
                    Remove Payment Method
                </ModalHeader>
                <div className="d-flex align-items-start justify-content-center gap-2">
                    <i className="fa fa-warning color-alert-negative" style={{fontSize: 32}} />
                    <p className="p-0 m-0">
                        <b
                            className="color-alert-negative"
                            style={{fontFamily: 'Founders SemiBold'}}>
                            Warning!
                        </b>{' '}
                        Are you sure you want to remove this payment method? You will have to re-add
                        it in future.
                    </p>
                </div>
                <ModalFooter>
                    <div className="d-flex align-items-center justify-content-end gap-4">
                        <button
                            className="btn btn--secondary"
                            onClick={() => setIsModalOpen(false)}>
                            Cancel
                        </button>
                        <IfElse condition={isDeleting}>
                            <button
                                className="btn btn--danger d-flex align-items-center justify-content-center gap-2"
                                disabled="disabled">
                                <i className="fa fa-spinner fa-spin" />
                                Deleting...
                            </button>
                            <button className="btn btn--danger" onClick={handleRemove}>
                                Remove Payment Method
                            </button>
                        </IfElse>
                    </div>
                </ModalFooter>
            </Modal>

            <div className="d-flex align-items-center justify-content-end">
                <div>
                    {/* Holding on this for now */}
                    {/* <button
                        className="p-0 m-0 color-accent-primary d-flex align-items-center justify-content-start"
                        onClick={() => setIsEditingPaymentMethod(isEditingPaymentMethod)}>
                        <i className="fa fa-pencil me-2" />
                        <u>Edit</u>
                    </button> */}
                    <IfElse condition={isDeleting}>
                        <button
                            className="color-structure-darker d-flex align-items-center justify-content-start gap-2"
                            disabled="disabled">
                            <i className="fa fa-spinner fa-spin" />
                            <u>Deleting...</u>
                        </button>
                        <button
                            className="p-0 m-0 color-alert-negative d-flex align-items-center justify-content-start"
                            onClick={() => setIsModalOpen(true)}>
                            <i className="fa fa-trash me-2" />
                            <u>Delete</u>
                        </button>
                    </IfElse>
                </div>
            </div>
        </div>
    );
};
